import { render, staticRenderFns } from "./Ongoing.vue?vue&type=template&id=58864642&scoped=true&"
import script from "./Ongoing.vue?vue&type=script&lang=js&"
export * from "./Ongoing.vue?vue&type=script&lang=js&"
import style0 from "./Ongoing.vue?vue&type=style&index=0&id=58864642&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58864642",
  null
  
)

export default component.exports